import React from "react";

const ContactMe: React.FC = () => {
  return (
    <div>
      <h1>Contact Me</h1>
      <p>Email: <a href="mailto:tim.12881@gmail.com">tim.12881@gmail.com</a></p>
    </div>
  );
}

export default ContactMe;
